import React, { useEffect, useState } from "react";
import PageBar from "../../components/dashboard/page-bar/PageBar";
import ListAllAdminUsers from "../../components/admin-users/list-all-adminUsers/ListAdminUsers";
import { deleteUser, getAllUser } from "../../components/apifile/ApiFiles";
import { Loaders } from "../Loaders";

const ListAllAdminUsersPage = () => {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();

  const [count, setCount] = useState(10)
  const [page, setPage] = useState(1)

  const [initialVlue, setInitialVlue] = useState({
    search: '',
  })
  const handleChange = (e) => {
    const clone = { ...initialVlue }
    const value = e.target.value
    const name = e.target.name
    clone[name] = value
    setInitialVlue(clone)
  }
  const getUserData = async (page) => {
    setLoader(true)
    const clone = { ...initialVlue, page: page, count: count }
    try {
      const res = await getAllUser(clone)
      setData(res?.data);
      setLoader(false)
    } catch (error) { }
  };

  const reset = async (page) => {
    setLoader(true)
    const clone = { search: '', page: page, count: count }
    try {
      const res = await getAllUser(clone)
      setData(res?.data);
      setInitialVlue({
        search: '',
      })
      setLoader(false)
    } catch (error) { }
  }

  useEffect(() => {
    getUserData(1);
  }, []);

  const handleDelete = async (id) => {
    try {
      const res = await deleteUser(id)
      getUserData(1)
    } catch (error) {
      alert("Error");
    }
  };
  const onChangeVal = (e) => {
    getUserData(e)
  };
  return (
    <>
      {loader && <Loaders />}
      <div className="pageWrapper">
        <PageBar title=" Admin Users List" />
        <h3 className="page-title">
          Manage Admin Users
        </h3>
        <ListAllAdminUsers data={data} handleDelete={handleDelete} onChangeVal={onChangeVal} initialVlue={initialVlue} handleChange={handleChange} getUserData={getUserData} reset={reset} />
      </div>
    </>
  );
};

export default ListAllAdminUsersPage;
